import { WrapperVariablesDefinition } from '../../generic/utils';

import { VariableTypes } from './interfaces';

const variables: WrapperVariablesDefinition<VariableTypes> = {
  tests: { startValue: undefined },
};

export const stateVariables = variables;
